"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Catcher = _interopRequireDefault(require("./Catcher"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorCatcher = function ErrorCatcher(_ref) {
  var children = _ref.children,
      active = _ref.active,
      appName = _ref.appName;
  return _react["default"].createElement("div", null, active ? _react["default"].createElement(_Catcher["default"], {
    appName: appName
  }, children) : _react["default"].createElement("div", null, children));
};

ErrorCatcher.propTypes = {
  /** Children to display */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,

  /** if this is active or not */
  active: _propTypes["default"].bool.isRequired,

  /** name of your application */
  appName: _propTypes["default"].string.isRequired
};
ErrorCatcher.defaultProps = {};
var _default = ErrorCatcher;
exports["default"] = _default;